import React, { ComponentProps, PropsWithChildren } from "react";

import "./Overlay.scss";

function Overlay({
  children,
  ...props
}: PropsWithChildren<ComponentProps<"div">>) {
  const { className = "", ...otherProps } = props;
  return (
    <div
      className={`custom-content-overlay MobileOnly ${className}`}
      {...otherProps}
    >
      {children}
    </div>
  );
}

export default Overlay;
